import Konva from 'konva';

export default {
    namespaced: true,

    state() {
        return {

        }
    },

    getters: {

    },

    mutations: {

    },

    actions: {
        async exportFilePNG({rootState, dispatch}) {
            // before exporting the image, it is important to set the original scale of the canvas,
            // because the image is created from the visible part of the canvas
            await dispatch('editor/setZoom', 1, {root: true});

            const pixelRatio = Konva.pixelRatio;

            return rootState['editor'].canvasStage.toDataURL({ pixelRatio });
        },

        async exportFileJSON({dispatch}) {
            let dataToSave = await dispatch('dataToSaveAsJSON');

            return "data:text/json;charset=utf-8," + encodeURIComponent(dataToSave);
        },

        dataToSaveAsJSON({rootState, rootGetters}) {
            return new Promise(resolve => {
                /*
                * data format:
                * {
                * "clientName": "Dakota Steel And Trim",
                * "trimName": "ODD910KW",
                * "paint": "Kestral White",
                * "trim": {"line1": 2.27,"line2": 1.25,"line3": 0.51,"angle1":68,"angle2":132,"hem1":0.5,"hem2":1.1}
                * }
                * */

                const points = rootState['editor'].points;
                const lines = rootGetters['line/getLinesWithoutFolds'](points);
                const angles = rootGetters['angles/getAngles'](points);
                const hems = rootGetters['editor/hems'];
                const startHem = hems[0];
                const endHem = hems[1];

                let trim = {};
                let key;
                let value;
                let index;


                // lines are starting from the second point for always have the previous point
                for (let i = 0; i < lines.length; i++) {
                    let line = lines[i];
                    index = i + 1;

                    if (line.type === "lineWithRibs") {
                        // line with ribs
                        // key = 'rib' + index;
                        value = rootGetters['line/getLineWithRibsStartingLength'](line);
                    }
                    else {
                        // simple line
                        // key = 'line' + index;
                        value = line.lengthInFeet;
                    }

                    let roundValue = rootGetters['editor/fractionsDecimalRound'](value);

                    // now lines and ribs will have a "line" name for both
                    key = 'line' + index;

                    // add a line to the trim object
                    trim[key] = roundValue;
                }


                // angles are starting from the third point for always have the previous point
                for (let i = 0; i < angles.length; i++) {
                    let angle = angles[i];
                    index = i + 1;

                    key = 'angle' + index;
                    value = angle.angleSize;

                    // add an angle to the trim object
                    trim[key] = value;
                }


                // hems
                index = 1;

                if (startHem) {
                    key = 'hem' + index;
                    value = startHem.size;

                    // add a hem to the trim object
                    trim[key] = value;

                    index += 1;
                }

                if (endHem) {
                    key = 'hem' + index;
                    value = endHem.size;

                    // add a hem to the trim object
                    trim[key] = value;
                }

                let userName = rootState['authentication'].userName;
                let trimName = rootState['trimInfo'].trimName;
                let description = rootState['trimInfo'].description;
                let paint = rootState['paint'].currentPaint?.name || 'none';

                let data = {
                    userName,
                    trimName,
                    description,
                    paint,
                    trim
                };

                let dataToSave = JSON.stringify(data);

                resolve(dataToSave);
            });
        },

    }
}